export const HOVER_BOX_SHADOW = '0px 0px 15px 2px rgba(0, 0, 0, 0.4)'
